module.exports = __webpack_public_path__ + "img/thumbnail_StandardDonkey_f_piebald.c1f6ecc8.png";